const logTagData = (data) => {
  if (console.table) console.table(data);
  else console.log(JSON.stringify(data, null, 2));
};

const logError = (err) => {
  console.error(err);
};

export { logTagData, logError };
